module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_24-72332cb2964890edc1887657f37d0031.png";